module.exports = __webpack_public_path__ + "5ed5af9c60e0ff244cc8009ff8c3231a.png";